import { render, staticRenderFns } from "./FullCollectionCta.vue?vue&type=template&id=215f4330&scoped=true&"
import script from "./FullCollectionCta.vue?vue&type=script&lang=js&"
export * from "./FullCollectionCta.vue?vue&type=script&lang=js&"
import style0 from "./FullCollectionCta.vue?vue&type=style&index=0&id=215f4330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f4330",
  null
  
)

export default component.exports